import { ACTIONS } from '../utils/constants';

const updateCurrentStepState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.CHANGE_CURRENT_STEP,
		payload: { currentStep: payload }
	});
};

const updateResultDataState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.RESULT_DATA,
		payload: { resultData: payload }
	});
};

const updatePageSettingsState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.INITIAL_DATA,
		payload: { pageSettings: payload }
	});
};

const updateOverviewState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.OVERVIEW,
		payload: {
			overview: payload
		}
	});
};

const updateStepsLockedState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.STEPS_LOCKED,
		payload: { stepsLocked: payload }
	});
};

const updateCheckoutFormContentState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.CHECKOUT_FORM_CONTENT,
		payload: { checkoutFormContent: payload }
	});
};

const updateIs3DPaymentState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.IS_3D_PAYMENT,
		payload: { is3DPayment: payload }
	});
};

const updateIsMobileState = ({ payload, dispatch }) => {
	dispatch({
		type: ACTIONS.IS_MOBILE,
		payload: { isMobile: payload }
	});
};

export {
	updateCheckoutFormContentState,
	updateCurrentStepState,
	updateIs3DPaymentState,
	updateIsMobileState,
	updateOverviewState,
	updatePageSettingsState,
	updateResultDataState,
	updateStepsLockedState
};
